{
  "INBOX_MGMT": {
    "HEADER": "กล่องข้อความ",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Your inbox is disconnected. You won't receive new messages until you reauthorize it.",
    "CLICK_TO_RECONNECT": "Click here to reconnect.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "ไม่มีกล่องข้อความที่เกี่ยวข้องในบัญชีนี้"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "เลือกช่อง",
        "BODY": "เลือกผู้ให้บริการที่คุณต้องการจะใช้สำหรับ Chatwoot"
      },
      "INBOX": {
        "TITLE": "สร้างกล่องข้อความ",
        "BODY": "ตรวจสอบบัญชีของคุณเเละสร้างกล่องข้อความ"
      },
      "AGENT": {
        "TITLE": "เพิ่มพนักงาน",
        "BODY": "เพิ่มพนักงานเพื่อสร้างกล่องข้อความ"
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "คุณพร้อมเเล้ว"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "ชื่อกล่องข้อความ",
        "PLACEHOLDER": "กรอกชื่อกล่องข้อความ (เช่น Acme Inc)",
        "ERROR": "โปรดกรอกชื่อกล่องข้อความให้ถูกต้อง"
      },
      "WEBSITE_NAME": {
        "LABEL": "ชื่อเว็บไซต์",
        "PLACEHOLDER": "กรอกชื่อเว็บไซต์ของคุณ (เช่น SnowBoltz Inc)"
      },
      "FB": {
        "HELP": "ป. ล. เมื่อลงชื่อเข้าใช้เราจะสามารถเข้าถึงข้อความของเพจของคุณเท่านั้น Chatwoot ไม่สามารถเข้าถึงข้อความส่วนตัวของคุณได้",
        "CHOOSE_PAGE": "เลือกหน้า",
        "CHOOSE_PLACEHOLDER": "เลือกหน้าจากรายชื่อ",
        "INBOX_NAME": "ชื่อกล่องข้อความ",
        "ADD_NAME": "เพิ่มชื่อให้กล่องข้อความของคุณ",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "เลือกค่า",
        "CREATE_INBOX": "สร้างกล่องข้อความ"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore.",
        "SETTINGS_RESTRICTED_WARNING": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
        "STATUS_LINK": "View status update"
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again",
        "NORTH_AMERICA_WARNING": "TikTok connections for North American accounts are temporarily unavailable while we wait for an update from the TikTok team."
      },
      "TWITTER": {
        "HELP": "ในการเพิ่มโปรไฟล์ Twitter ของคุณเป็นช่องคุณต้องตรวจสอบสิทธิ์โปรไฟล์ Twitter ของคุณโดยคลิกที่ \"ลงชื่อเข้าใช้ด้วย Twitter\" ",
        "ERROR_MESSAGE": "เกิดข้อผิดพลาดในการเชื่อมต่อกับ Twitter โปรดลองอีกครั้ง",
        "TWEETS": {
          "ENABLE": "สร้างการสนทนาใหม่จากการกล่าวถึงในทวีต"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "ช่องเว็บไซต์",
        "DESC": "สร้างช่องสำหรับเว็บของคุณเเละเริ่มที่จะช่วยเหลือลูกค้าของคุณด้วยวิดเจ็ต",
        "LOADING_MESSAGE": "กำลังสร้างช่องช่วยเหลือสำหรับเว็บไซต์",
        "CHANNEL_AVATAR": {
          "LABEL": "รูปของช่อง"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "ลิ้ง Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "กรุณากรอกลิ้งที่ถูกต้อง"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "โดเมนเว็บไซต์",
          "PLACEHOLDER": "กรอกโดเมนเว็บไซต์ของคุณ (เช่น snowboltz.net)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "ข้อความยินดีต้อนรับส่วนหัว",
          "PLACEHOLDER": "สวัสดี!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "ข้อความยินดีต้อนรับส่วนล่าง",
          "PLACEHOLDER": "เราทำให้การติดต่อกับเราเป็นเรื่องง่าย ถามเราได้ทุกอย่างหรือแบ่งปันความคิดเห็นของคุณ"
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "ข้อความต้อนรับ",
          "PLACEHOLDER": "โดยทั่วไป Acme Inc จะตอบกลับภายในไม่กี่ชั่วโมง"
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "เปิดข้อความต้อนรับ",
          "HELP_TEXT": "ส่งข้อความทักทายอัตโนมัติหลังจากมีการสร้างการสนทนาใหม่",
          "ENABLED": "เปิด",
          "DISABLED": "ปิด"
        },
        "REPLY_TIME": {
          "TITLE": "ตั้งเวลาตอบกลับ",
          "IN_A_FEW_MINUTES": "ในไม่กี่นาที",
          "IN_A_FEW_HOURS": "ในไม่กี่ชั่วโมง",
          "IN_A_DAY": "ในหนึ่งวัน",
          "HELP_TEXT": "เวลาในการตอบกลับจะแสดงใน live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "สีของวิดเจ็ต",
          "PLACEHOLDER": "อัพเดทสีที่ใช้ในวิดเจ็ต"
        },
        "SUBMIT_BUTTON": "สร้างกล่องข้อความ",
        "API": {
          "ERROR_MESSAGE": "ไม่สามารถสร้างช่องทางเว็บไซต์ได้ โปรดลองใหม่อีกครั้ง"
        }
      },
      "TWILIO": {
        "TITLE": "ช่องทาง Twilio SMS/WhatsApp",
        "DESC": "เชื่อมต่อกับ Twilio และเริ่มสนับสนุนลูกค้าของคุณผ่าน SMS หรือ Whatsapp",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "กรุณากรอก Twilio Account SID",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "ประเภทช่อง",
          "ERROR": "กรุณาเลือกประเภทช่อง"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "กรุณาหรอก Twilio Auth Token",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "CHANNEL_NAME": {
          "LABEL": "ชื่อกล่องข้อความ",
          "PLACEHOLDER": "โปรดกรอกชื่อกล่องข้อความ",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "PHONE_NUMBER": {
          "LABEL": "หมายเลขโทรศัพท์",
          "PLACEHOLDER": "กรุณากรอกหมายเลขโทรศัพท์ที่จะส่งข้อความ",
          "ERROR": "กรุณากรอกเบอร์โทรศัพท์ที่เริ่มด้วย '+' และไม่มีการเว้นวรรค"
        },
        "API_CALLBACK": {
          "TITLE": "ลิ้งเรียกกลับ",
          "SUBTITLE": "คุณต้องตั้งค่าลิ้งเรียกกลับใน Twilio ด้วยลิ้งที่มาจากที่นี่"
        },
        "SUBMIT_BUTTON": "สร้างช่อง Twilio",
        "API": {
          "ERROR_MESSAGE": "เราไม่สามารถยืนยันใบรับลองของ Twilio ได้กรุณาลองใหม่อีกครั้ง"
        }
      },
      "SMS": {
        "TITLE": "ช่องทาง SMS",
        "DESC": "เริ่มสนับสนุนลูกค้าของคุณผ่านช่องทาง SMS",
        "PROVIDERS": {
          "LABEL": "ผู้ให้บริการ API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth"
        },
        "API": {
          "ERROR_MESSAGE": "เราไม่สามารถบันทึกช่องทาง SMS ได้"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "โปรดกรอก Account ID ของ Bandwidth",
            "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "โปรดกรอก Bandwidth Application ID",
            "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
          },
          "INBOX_NAME": {
            "LABEL": "ชื่อกล่องข้อความ",
            "PLACEHOLDER": "โปรดกรอกชื่อกล่องข้อความ",
            "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
          },
          "PHONE_NUMBER": {
            "LABEL": "หมายเลขโทรศัพท์",
            "PLACEHOLDER": "กรุณากรอกหมายเลขโทรศัพท์ที่จะส่งข้อความ",
            "ERROR": "กรุณากรอกเบอร์โทรศัพท์ที่เริ่มด้วย '+' และไม่มีการเว้นวรรค"
          },
          "SUBMIT_BUTTON": "สร้างช่องทาง Bandwidth",
          "API": {
            "ERROR_MESSAGE": "เราไม่สามารถยืนยันใบรับรองของ Bandwidth ได้กรุณาลองใหม่อีกครั้ง"
          },
          "API_CALLBACK": {
            "TITLE": "ลิ้งเรียกกลับ",
            "SUBTITLE": "คุณต้องตั้งค่าข้อความ callback URL ใน Bandwidth ด้วยลิงก์ที่มาจากที่นี่"
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "ช่องทาง WhatsApp",
        "DESC": "เริ่มสนับสนุนลูกค้าของคุณผ่านช่องทาง WhatsApp",
        "PROVIDERS": {
          "LABEL": "ผู้ให้บริการ API",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "WhatsApp Cloud",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360Dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "ชื่อกล่องข้อความ",
          "PLACEHOLDER": "กรุณากรอกชื่อกล่องข้อความ",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "PHONE_NUMBER": {
          "LABEL": "หมายเลขโทรศัพท์",
          "PLACEHOLDER": "กรุณากรอกหมายเลขโทรศัพท์ที่จะส่งข้อความ",
          "ERROR": "กรุณากรอกเบอร์โทรศัพท์ที่เริ่มด้วย '+' และไม่มีการเว้นวรรค"
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "Phone number ID",
          "PLACEHOLDER": "Please enter the Phone number ID obtained from Facebook developer dashboard.",
          "ERROR": "โปรดกรอกค่าที่ถูกต้อง"
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "Business Account ID",
          "PLACEHOLDER": "Please enter the Business Account ID obtained from Facebook developer dashboard.",
          "ERROR": "โปรดกรอกค่าที่ถูกต้อง"
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Webhook Verify Token",
          "PLACEHOLDER": "Enter a verify token which you want to configure for Facebook webhooks.",
          "ERROR": "โปรดกรอกค่าที่ถูกต้อง"
        },
        "API_KEY": {
          "LABEL": "API key",
          "SUBTITLE": "ตั้งค่า WhatsApp API key",
          "PLACEHOLDER": "API key",
          "ERROR": "โปรดกรอกค่าที่ถูกต้อง"
        },
        "API_CALLBACK": {
          "TITLE": "ลิ้งเรียกกลับ",
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "ลิ้ง Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "SUBMIT_BUTTON": "สร้างช่องทาง WhatsApp",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "เราไม่สามารถบันทึกช่องทาง WhatsApp ได้"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "หมายเลขโทรศัพท์",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Account SID",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Auth Token",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "API Key Secret",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "ช่อง API",
        "DESC": "สร้างช่องด้วย API เเละเริ่มช่วยเหลือลูกค้าของคุณ",
        "CHANNEL_NAME": {
          "LABEL": "ชื่อช่อง",
          "PLACEHOLDER": "กรุณากรอกชื่อช่อง",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "WEBHOOK_URL": {
          "LABEL": "ลิ้ง Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "ลิ้ง Webhook"
        },
        "SUBMIT_BUTTON": "สร้างช่อง API",
        "API": {
          "ERROR_MESSAGE": "ไม่สามารถบันทึกช่อง API ได้"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "ช่องอีเมล์",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "ชื่อช่อง",
          "PLACEHOLDER": "กรุณากรอกชื่อช่อง",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "EMAIL": {
          "LABEL": "อีเมล์",
          "SUBTITLE": "อีเมล์ที่ใช้สำหรับลูกค้าที่จะส่งข้อความตั๋วช่วยเหลือ",
          "PLACEHOLDER": "อีเมล์"
        },
        "SUBMIT_BUTTON": "สร้างช่องอีเมล์",
        "API": {
          "ERROR_MESSAGE": "เราไม่สามารถบันทึกช่องอีเมล์ได้"
        },
        "FINISH_MESSAGE": "เริ่มนำเข้าอีเมล์ของคุณไปที่อยู่อีเมล์",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "กดที่นี้",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "ช่องทาง LINE",
        "DESC": "เชื่อมต่อกับ LINE และเริ่มสนับสนุนลูกค้าของคุณ",
        "CHANNEL_NAME": {
          "LABEL": "ชื่อช่อง",
          "PLACEHOLDER": "กรุณากรอกชื่อช่อง",
          "ERROR": "ฟิลด์นี้จำเป็นต้องกรอก"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "สร้างช่องทาง LINE",
        "API": {
          "ERROR_MESSAGE": "เราไม่สามารถบันทึกช่องทาง LINE นี้ได้"
        },
        "API_CALLBACK": {
          "TITLE": "ลิ้งเรียกกลับ",
          "SUBTITLE": "คุณต้องตั้งค่า webhook URL ที่ LINE ด้วย URL นี้"
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "ช่องทาง Telegram",
        "DESC": "เชื่อมต่อกับ Telegram และเริ่มสนับสนุนลูกค้าของคุณ",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "ตั้งค่า bot token ที่ได้จาก Telegram BotFather",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "สร้างช่องทาง Telegram",
        "API": {
          "ERROR_MESSAGE": "เราไม่สามารถบันทึกช่องทาง Telegram นี้ได้"
        }
      },
      "AUTH": {
        "TITLE": "เลือกช่องทาง",
        "DESC": "Chatwoot รองรับ live-chat widget, Facebook, Twitter, WhatsApp, Email และช่องทางอื่น ๆ ถ้าคุณต้องการสร้างช่องทางพิเศษ คุณสามารถสร้างได้โดยใช้ API channel เลือกช่องทางด้านล่างนี้เพื่อดำเนินการต่อ",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Website",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "เฟสบุ๊ค",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "อีเมล์",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "พนักงาน",
        "DESC": "คุณสามารถเพิ่มพนักงานเพื่อจัดการกล่องข้อความที่สร้างใหม่ พนักงานที่ได้รับสิทธิ์เท่านั้นที่สามารถเข้าถึงกล่องข้อความนี้ได้ พนักงานที่ไม่มีสิทธิ์จะไม่สามารถเห็นหรือใช้กล่องสนทนานี้ได้ <br><b>หมายเหตุ:</b>ในฐานะของผู้ดูแล คุณจะสามารถเพิ่มตัวเองในกล่องข้อความทุกกล่องที่คุณสร้าง",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "เลือกพนักงานสำหรับกล่องข้อความนี้"
      },
      "DETAILS": {
        "TITLE": "รายละเอียดกล่องข้อความ",
        "DESC": "คุณสามารถเลือก facebook Page ที่ต้องการเชื่อมต่อกับ Chatwoot จากรายการข้างล่าง คุณยังสามารถตั้งชื่อให้กล่องข้อความของคุณเพื่อการจัดการที่ง่ายขึ้น"
      },
      "FINISH": {
        "TITLE": "เรียบร้อย!",
        "DESC": "เชื่อมต่อ Facebook Page กับ Chatwoot สำเร็จแล้ว เมื่อมีคนส่งข้อความมาที่เพจของคุณ การสนทนาจะแสดงในกล่องข้อความของคุณโดยอัตโนมัติ<br>เรายังได้เตรียมสคริปท์สำหรับสร้าง widget เพื่อให้คุณนำไปติดตั้งที่เว็บไซต์ของคุณได้ง่ายขึ้นอีกด้วย เมื่อคุณติดตั้งสำเร็จแล้ว ลูกค้าสามารถส่งข้อความมาหาคุณได้โดยตรงจากทางเว็บไซต์ของคุณโดยที่ไม่ต้องใช้เครื่องมืออื่นๆ อีก และการสนทนาจะมาปรากฎบน Chatwoot <br>เจ๋งใช่มั้ยล่ะ? นั่นแหละที่พวกเราพยายามจะเป็น :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "กำลังตรวจสอบสิทธิ์ของคุณกับ Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "มีข้อผิดพลาดเกิดขึ้น โปรดโหลดหน้านี้ใหม่อีกครั้ง",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "กำลังสร้างกล่องข้อความ...",
      "TITLE": "ตั้งค่ารายละเอียดกล่องข้อความ",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "เพิ่มพนักงาน",
      "ADD_AGENTS": "กำลังเพิ่มพนักงานสำหรับกล่องข้อความนี้..."
    },
    "FINISH": {
      "TITLE": "กล่องข้อความของคุณพร้อมใช้แล้ว!",
      "MESSAGE": "ตอนนี้คุณสามารถมีส่วนร่วมกับลูกค้าของคุณผ่านช่องทางใหม่ได้แล้ว ขอให้มีความสุขกับการคุย",
      "BUTTON_TEXT": "พาฉันไปที่นั่น",
      "MORE_SETTINGS": "ตั้งค่าเพิ่มเติม",
      "WEBSITE_SUCCESS": "คุณได้สร้างช่องทางเว็บไซต์สำเร็จแล้ว คัดลอกโค้ดข้างล่างแล้วนำไปแปะที่เว็บไซต์ของคุณ ครั้งถัดไปที่ลูกค้าใช้ live chat การสนทนาจะปรากฎที่กล่องข้อความของคุณโดยอัตโนมัติ",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "ขอสิทธิ์อีกครั้ง",
    "VIEW": "ดู",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "อัปเดตการตั้งค่ากล่องข้อความเรียบร้อยแล้ว",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "อัปเดตการมอบหมายอัตโนมัติเรียบร้อยแล้ว",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "เปิด",
        "DISABLED": "ปิด"
      },
      "ENABLE_CSAT": {
        "ENABLED": "เปิด",
        "DISABLED": "ปิด"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "จาก",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "เปิด",
        "DISABLED": "ปิด"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "เปิด",
        "DISABLED": "ปิด"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "เปิดใช้งาน"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "ลบ",
      "AVATAR_DELETE_BUTTON_TEXT": "ลบรูป",
      "CONFIRM": {
        "TITLE": "ยืนยันการลบ",
        "MESSAGE": "คุณต้องการที่จะลบไหม ",
        "PLACE_HOLDER": "โปรดพิมพ์ {inboxName} เพื่อยืนยัน",
        "YES": "เอาเลย ",
        "NO": "ไม่อะเก็บไว้ "
      },
      "API": {
        "SUCCESS_MESSAGE": "ลบกล่องข้อความเรียบร้อยแล้ว",
        "ERROR_MESSAGE": "ไม่สามารถลบกล่องข้อความได้ โปรดลองใหม่อีกครั้ง",
        "AVATAR_SUCCESS_MESSAGE": "ลบรูปเรียบร้อยแล้ว",
        "AVATAR_ERROR_MESSAGE": "ไม่สามารถลบรูปของกล่องข้อความได้ โปรดลองอีกครั้งในภายหลัง"
      }
    },
    "TABS": {
      "SETTINGS": "ตั้งค่า",
      "COLLABORATORS": "การร่วมมือ",
      "CONFIGURATION": "ตั้งค่า",
      "CAMPAIGN": "แคมเปญ",
      "PRE_CHAT_FORM": "แบบสอบถามก่อนแชท",
      "BUSINESS_HOURS": "เวลาทำการ",
      "WIDGET_BUILDER": "เครื่องมือสร้าง Widget",
      "BOT_CONFIGURATION": "Bot Configuration",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "CSAT",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      },
      "INBOUND": {
        "LABEL": "Allow incoming calls",
        "DESCRIPTION": "Let customers call this number. When turned off, incoming calls are declined automatically — agents aren't notified and no conversation is created. Agents can still place outgoing calls."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "ขณะนี้"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "ตั้งค่า",
    "FEATURES": {
      "LABEL": "ฟีเจอร์",
      "DISPLAY_FILE_PICKER": "แสดงตัวเลือกไฟล์ใน widget",
      "DISPLAY_EMOJI_PICKER": "แสดงตัวเลือกอีโมจิใน widget",
      "ALLOW_END_CONVERSATION": "อนุญาตให้ลูกค้าปิดการสนทนาจาก widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "ใส่ปุ่มนี้ใน body tag",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "พนักงาน",
      "INBOX_AGENTS_SUB_TEXT": "เพิ่มหรือลบพนักงานจากกล่องสนทนานี้",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "อัพเดท",
      "ENABLE_EMAIL_COLLECT_BOX": "เปิดใช้งานกล่องรวมอีเมล",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "เปิดหรือปิดการใช้งานกล่องรวมอีเมลสำหรับการสนทนาใหม่",
      "AUTO_ASSIGNMENT": "เปิดการมอบหมายงานอัตโนมัติ",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "เปิดให้มีการสนทนาต่อทางอีเมลได้",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "การสนทนาจะสามารถดำเนินการต่อผ่านทางอีเมลได้ หากลูกค้าให้อีเมลไว้",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "ตั้งค่ากล่องข้อความ",
      "INBOX_UPDATE_SUB_TEXT": "อัปเดตกล่องข้อความ",
      "AUTO_ASSIGNMENT_SUB_TEXT": "เปิดหรือปิดระบบมอบหมายงานอัตโนมัติสำหรับข้อความใหม่ให้กับพนักงานในกล่องสนทนานี้",
      "HMAC_VERIFICATION": "การตรวจสอบตัวตนผู้ใช้งาน",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "บังคับใช้การตรวจสอบตัวตนผู้ใช้งาน",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "INBOX_IDENTIFIER": "ตัวระบุกล่องข้อความ",
      "INBOX_IDENTIFIER_SUB_TEXT": "ใช้ 'ตัวระบุกล่องข้อความ' ที่ปรากฎที่นี่เพื่อรับรองสิทธิ์ API clients ของคุณ",
      "FORWARD_EMAIL_TITLE": "ส่งต่อไปยังอีเมล",
      "FORWARD_EMAIL_SUB_TEXT": "เริ่มส่งต่ออีเมลของคุณไปยังที่อยู่ตามนี้",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "อนุญาตให้รับข้อความหลังจากจบการสนทนาแล้ว",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "อนุญาตให้ลูกค้าส่งข้อความหลังจากจบการสนทนาแล้ว",
      "WHATSAPP_SECTION_SUBHEADER": "This API Key is used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Enter the new API key to be used for the integration with the WhatsApp APIs.",
      "WHATSAPP_SECTION_TITLE": "API Key",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Update API Key",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Enter the new API Key here",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "อัพเดท",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_MANUAL_TRANSFER_TITLE": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUBHEADER": "This inbox was connected through WhatsApp embedded signup, which is no longer supported. Enter the WhatsApp Cloud API credentials from your own Meta app to switch this inbox to a manual setup. Configure the webhook in your Meta app using the verification token above before switching.",
      "WHATSAPP_MANUAL_TRANSFER_PHONE_NUMBER_ID_LABEL": "Phone Number ID",
      "WHATSAPP_MANUAL_TRANSFER_BUSINESS_ACCOUNT_ID_LABEL": "Business Account ID",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_LABEL": "API Key",
      "WHATSAPP_MANUAL_TRANSFER_API_KEY_PLACEHOLDER": "Enter a permanent access token from your Meta app",
      "WHATSAPP_MANUAL_TRANSFER_BUTTON": "Switch to Manual Setup",
      "WHATSAPP_MANUAL_TRANSFER_SUCCESS": "Inbox switched to manual setup successfully.",
      "WHATSAPP_MANUAL_TRANSFER_ERROR": "Could not switch to manual setup. Please verify the credentials and try again.",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "เชื่อมต่อ",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Webhook Verification Token",
      "WHATSAPP_WEBHOOK_SUBHEADER": "This token is used to verify the authenticity of the webhook endpoint.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_MANUAL_MIGRATION": {
        "BANNER": {
          "TITLE": "Manual setup recommended",
          "DESCRIPTION": "This inbox connects through the shared Meta app used for embedded signup, which recent Meta restrictions have affected. To avoid similar issues in the future, we recommend reconnecting it with your own Meta app.",
          "START": "Start manual migration",
          "GUIDE": "View guide"
        },
        "DIALOG": {
          "EYEBROW": "WhatsApp manual migration",
          "TITLE": "Reconnect WhatsApp inbox",
          "CLOSE": "ปิด",
          "ACTION_REQUIRED_TITLE": "Reconnect with your own Meta app",
          "ACTION_REQUIRED_DESCRIPTION": "Inboxes connected through your own Meta app are not affected by restrictions on the shared embedded signup app. This guided flow updates the WhatsApp API connection without creating a new inbox.",
          "GUIDE_LINK": "Open the manual setup guide",
          "PRESERVED_TITLE": "Preserved",
          "PRESERVED_DESCRIPTION": "Conversations, contacts, collaborators, routing, business hours, and inbox settings.",
          "UPDATED_TITLE": "Updated",
          "UPDATED_DESCRIPTION": "WABA ID, phone number ID, access token, and webhook configuration.",
          "WABA_ID": "WABA ID",
          "WABA_PLACEHOLDER": "Enter WABA ID",
          "WABA_HELP": "The WhatsApp Business Account that owns this phone number.",
          "PHONE_NUMBER_ID": "Phone Number ID",
          "PHONE_NUMBER_PLACEHOLDER": "Enter Phone Number ID",
          "PHONE_NUMBER_HELP": "Meta's unique ID for the WhatsApp number connected to this inbox.",
          "DISPLAY_PHONE_NUMBER": "Display phone number",
          "DISPLAY_PHONE_NUMBER_PLACEHOLDER": "Enter display phone number",
          "DISPLAY_PHONE_NUMBER_HELP": "The customer-facing WhatsApp number. This cannot be changed during migration.",
          "ACCESS_TOKEN": "Permanent access token or system user token",
          "ACCESS_TOKEN_PLACEHOLDER": "Paste access token",
          "TOKEN_HELP_PREFIX": "The token must include",
          "TOKEN_HELP_MIDDLE": "เพิ่ม",
          "TOKEN_HELP_SUFFIX": "for template sync and template management.",
          "MESSAGING_PERMISSION": "whatsapp_business_messaging.",
          "MANAGEMENT_PERMISSION": "whatsapp_business_management",
          "REVIEW_TITLE": "Review before reconnecting",
          "INBOX": "กล่องข้อความ",
          "PHONE_NUMBER": "หมายเลขโทรศัพท์",
          "NOT_ENTERED": "Not entered",
          "VERIFY_NOTICE": "Chatwoot will verify these credentials with Meta before applying any changes. If verification fails, the current configuration is left untouched.",
          "BACK": "ย้อนกลับ",
          "CANCEL": "ยกเลิก",
          "CONTINUE": "Continue",
          "REVIEW_MIGRATION": "Review migration",
          "RECONNECT": "Reconnect WhatsApp inbox"
        },
        "STEPS": {
          "BEFORE_YOU_START": {
            "TITLE": "Before you start",
            "DESCRIPTION": "This reconnects the WhatsApp API details for this inbox. Conversations, collaborators, routing, business hours, CSAT, and bot settings will be preserved."
          },
          "BUSINESS_DETAILS": {
            "TITLE": "Business details",
            "DESCRIPTION": "Enter the WhatsApp assets from the customer Meta Business account."
          },
          "ACCESS_TOKEN": {
            "TITLE": "Access token",
            "DESCRIPTION": "Paste a permanent access token or system user token with WhatsApp permissions."
          },
          "REVIEW_MIGRATION": {
            "TITLE": "Review migration",
            "DESCRIPTION": "Confirm the connection details before reconnecting this inbox. Chatwoot will verify the token, WABA, and phone number with Meta before applying changes."
          }
        }
      },
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings"
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "NONE": "ไม่มี",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "กรุณากรอกค่าที่มากกว่า 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "ASSIGNMENT": {
      "TITLE": "Conversation Assignment",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "ใช้งานอยู่",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "ยกเลิก",
      "CONFIRM_DELETE": "ลบ",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "ขอสิทธิ์อีกครั้ง",
      "SUBTITLE": "การเชื่อมต่อกับ Facebook หมดอายุแล้ว โปรดเชื่อมต่อใหม่อีกครั้ง",
      "MESSAGE_SUCCESS": "เชื่อมต่อสำเร็จ",
      "MESSAGE_ERROR": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "แบบสอบถามก่อนเริ่มแชทจะช่วยเก็บข้อมูลลูกค้าก่อนที่จะเริ่มการสนทนา",
      "SET_FIELDS": "รูปแบบของแบบสอบถามก่อนเริ่มแชท",
      "SET_FIELDS_HEADER": {
        "FIELDS": "รูปแบบ",
        "LABEL": "ป้ายกำกับ",
        "PLACE_HOLDER": "ข้อความตัวอย่าง",
        "KEY": "คีย์",
        "TYPE": "ประเภท",
        "REQUIRED": "โปรดระบุ"
      },
      "ENABLE": {
        "LABEL": "เปิดใช้งานแบบสอบถามก่อนเริ่มแชท",
        "OPTIONS": {
          "ENABLED": "ใช่",
          "DISABLED": "ไม่"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "ข้อความสำหรับแบบสอบถามก่อนเริ่มแชท",
        "PLACEHOLDER": "ลูกค้าจะเห็นข้อความนี้ขณะที่กรอกข้อมูลในแบบสอบถาม"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "ลูกค้าควรให้ชื่อและอีเมลก่อนเริ่มสนทนา"
      }
    },
    "CSAT": {
      "TITLE": "เปิด CSAT",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "ข้อความ",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Language",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Go back"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "มี",
          "DOES_NOT_CONTAINS": "ไม่มี"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "ตั้งค่าความพร้อมในการให้บริการ",
      "SUBTITLE": "ตั้งค่าความพร้อมในการให้บริการของคุณบน livechat widget",
      "WEEKLY_TITLE": "ตั้งค่าเวลาทำการ",
      "TIMEZONE_LABEL": "ตั้งค่าโซนเวลา",
      "UPDATE": "อัปเดตเวลาทำการ",
      "TOGGLE_AVAILABILITY": "แสดงความพร้อมในการให้บริการสำหรับกล่องข้อความนี้",
      "UNAVAILABLE_MESSAGE_LABEL": "ข้อความที่ต้องการแสดงเมื่ออยู่นอกเวลาทำการ",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "DAY": "วัน",
        "AVAILABILITY": "สถานะ",
        "HOURS": "Hours",
        "ENABLE": "เปิดใช้ความพร้อมในการให้บริการสำหรับวันนี้",
        "UNAVAILABLE": "ไม่พร้อมให้บริการ",
        "VALIDATION_ERROR": "เวลาเปิดทำการควรเริ่มก่อนเวลาปิดทำการ",
        "CHOOSE": "เลือก"
      },
      "ALL_DAY": "ทั้งวัน"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "ตั้งค่ารายละเอียด IMAP",
      "NOTE_TEXT": "โปรดตั้งค่า IMAP หากคุณต้องการเปิดใช้ SMTP",
      "UPDATE": "อัปเดตการตั้งค่า IMAP",
      "TOGGLE_AVAILABILITY": "เปิดใช้งานการตั้งค่า IMAP สำหรับกล่องข้อความนี้",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "อัปเดตการตั้งค่า IMAP สำเร็จแล้ว",
        "ERROR_MESSAGE": "ไม่สามารถอัปเดตการตั้งค่า IMAP ได้"
      },
      "ADDRESS": {
        "LABEL": "ที่อยู่",
        "PLACE_HOLDER": "ที่อยู่ (เช่น imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "พอร์ท",
        "PLACE_HOLDER": "พอร์ท"
      },
      "LOGIN": {
        "LABEL": "เข้าสู่ระบบ",
        "PLACE_HOLDER": "เข้าสู่ระบบ"
      },
      "PASSWORD": {
        "LABEL": "หรัสผ่าน",
        "PLACE_HOLDER": "หรัสผ่าน"
      },
      "ENABLE_SSL": "เปิดใช้ SSL",
      "AUTH_MECHANISM": "การตรวจสอบสิทธิ์"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "ตั้งค่า SMTP",
      "UPDATE": "อัปเดตการตั้งค่า SMTP",
      "TOGGLE_AVAILABILITY": "เปิดใช้งาน SMTP กับกล่องสนทนานี้",
      "TOGGLE_HELP": "การเปิด SMTP จะช่วยให้ระบบส่งอีเมล์ได้",
      "EDIT": {
        "SUCCESS_MESSAGE": "ตั้งค่า SMTP สำเร็จแล้ว",
        "ERROR_MESSAGE": "ไม่สามารถตั้งค่า SMTP ได้"
      },
      "ADDRESS": {
        "LABEL": "ที่อยู่",
        "PLACE_HOLDER": "ที่อยู่ (เช่น smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "พอร์ท",
        "PLACE_HOLDER": "พอร์ท"
      },
      "LOGIN": {
        "LABEL": "เข้าสู่ระบบ",
        "PLACE_HOLDER": "เข้าสู่ระบบ"
      },
      "PASSWORD": {
        "LABEL": "หรัสผ่าน",
        "PLACE_HOLDER": "หรัสผ่าน"
      },
      "DOMAIN": {
        "LABEL": "โดเมน",
        "PLACE_HOLDER": "โดเมน"
      },
      "ENCRYPTION": "การเข้ารหัส",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "เปิดโหมดตรวจสอบ SSL",
      "AUTH_MECHANISM": "การตรวจสอบสิทธิ์"
    },
    "NOTE": "หมายเหตุ: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "ชื่อเว็บไซต์",
          "PLACE_HOLDER": "กรอกชื่อเว็บไซต์ของคุณ (เช่น SnowBoltz Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "ข้อความยินดีต้อนรับส่วนหัว",
          "PLACE_HOLDER": "สวัสดี!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "ข้อความยินดีต้อนรับส่วนล่าง",
          "PLACE_HOLDER": "เราทำให้การติดต่อกับเราเป็นเรื่องง่าย ถามเราได้ทุกอย่างหรือแบ่งปันความคิดเห็นของคุณ"
        },
        "REPLY_TIME": {
          "LABEL": "ระยะเวลาในการตอบกลับ",
          "IN_A_FEW_MINUTES": "ในไม่กี่นาที",
          "IN_A_FEW_HOURS": "ในไม่กี่ชั่วโมง",
          "IN_A_DAY": "ในหนึ่งวัน"
        },
        "WIDGET_COLOR_LABEL": "สีของวิดเจ็ต",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "ประเภท:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "คุยกับเรา",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "คุยกับเรา"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "ซ้าย",
          "RIGHT": "ขวา"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "มาตรฐาน",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "ปกติจะตอบกลับภายในไม่กี่นาที",
        "IN_A_FEW_HOURS": "ปกติจะตอบกลับในไม่กี่ชั่วโมง",
        "IN_A_DAY": "ปกติจะตอบกลับภายใน 1 วัน"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "เริ่มการสนทนา",
        "CHAT_INPUT_PLACEHOLDER": "พิมพ์ข้อความ"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "เราไม่อยู่"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Powered by Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Other Providers",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Website",
      "TWITTER_PROFILE": "ทวิตเตอร์",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "อีเมล์",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "ช่อง API",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
